import React, { useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import { authProvider } from "../../provider/authProvider";
import "./NotRegisteredPage.css";
import { postLogAPI } from "./actions";

export default function NotRegisteredPage() {
  const postLogUserAPI = async () => {
    let body = {
      UserId: null,
      TableName: "Login",
      TableRowId: 0,
      CrudAction: "Erro Login",
      EventDescription: `Usuario de email ${
        authProvider.getAccount().userName
      } tentou o login e deu erro.`,
    };
    await postLogAPI(body);
  };

  useEffect(() => {
    postLogUserAPI();
  });

  return (
    <Card border='primary'>
      <Card.Body>
        <Card.Text>
          Você precisa pedir permissão para utilizar o sistema!
        </Card.Text>
        <Card.Footer className='text-center'>
          <Button
            onClick={() => authProvider.logout()}
            className='btn btn-light-primary font-weight-bold divFooter'
          >
            Clique aqui para sair
          </Button>
        </Card.Footer>
        Nome de usuario: {authProvider.getAccount().userName}
      </Card.Body>
    </Card>
  );
}
